import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import "./SystemEducation.css";

const VerticalSlider = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (selectedImage) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => document.body.classList.remove('no-scroll');
  }, [selectedImage]);

 const altTextList = [
  "Solar, battery and off-grid power in Ontario",
  "Ontario solar and battery specialists",
  "Your hydro bill has four parts",
  "Time-of-Use versus Ultra-Low Overnight",
  "Peak shaving explained",
  "Solar, battery, hybrid and off-grid systems",
  "The rebate build",
  "Net metering and off-grid systems",
  "Outage protection without solar",
  "EG4 systems",
  "EP Cube 2.0, EcoFlow, panels and generators",
  "Home Renovation Savings rebate",
  "2026 project price ranges",
  "Our seven-step process",
  "What we need from you",
  "Warranty and support",
  "Our installs",
  "Thank you"
];

  const slides = Array.from({ length: 18 }, (_, i) => ({
    id: i + 1,
    src: `/images/systemeducation/${i + 1}.png`,
    alt: altTextList[i]
  }));

  return (
    <>
      <div className="vertical-slider-container no-scrollbar">
        {slides.map((slide) => (
          <section key={slide.id} className="vertical-slide">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: false, amount: 0.2 }}
              style={{ width: '85%', maxWidth: '1000px', cursor: 'zoom-in' }}
              onClick={() => setSelectedImage(slide.src)}
            >
              <img 
                src={slide.src} 
                alt={slide.alt} 
                style={{ 
                  width: '100%', 
                  maxHeight: '80vh', 
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 10px 30px rgba(0,0,0,0.15))', 
                  borderRadius: "12px"
                }} 
              />
            </motion.div>
          </section>
        ))}
      </div>

      {/* Image Preview Popup */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div 
            className="image-preview-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            {/* Close Button UI */}
            <div style={{ position: 'absolute', top: '20px', right: '30px', color: '#fff', fontSize: '30px', fontWeight: 'lighter' }}>&times;</div>
            
            <motion.img 
              src={selectedImage}
              className="preview-img"
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export { VerticalSlider };